// Section: Tax Calculation Mode (gated by partsFinancialEngine)
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { useFeatureFlag } from '@/hooks/useFeatureFlags';

export type TaxMode = 'manual' | 'suggested' | 'api';

interface Props {
  value: TaxMode;
  onChange: (m: TaxMode) => void;
}

export function TaxModeSection({ value, onChange }: Props) {
  const enabled = useFeatureFlag('partsFinancialEngine');
  if (!enabled) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Tax Calculation Mode</CardTitle>
        <CardDescription>How effective tax rates are determined for this shop.</CardDescription>
      </CardHeader>
      <CardContent>
        <RadioGroup value={value} onValueChange={(v) => onChange(v as TaxMode)} className="space-y-3">
          <div className="flex items-start gap-3">
            <RadioGroupItem value="manual" id="mode-manual" className="mt-1" />
            <div>
              <Label htmlFor="mode-manual" className="font-medium cursor-pointer">Manual</Label>
              <p className="text-sm text-muted-foreground">Enter tax rates directly. Always treated as the source of truth.</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <RadioGroupItem value="suggested" id="mode-suggested" className="mt-1" />
            <div>
              <Label htmlFor="mode-suggested" className="font-medium cursor-pointer">Suggested Lookup</Label>
              <p className="text-sm text-muted-foreground">Pull suggested rates from your business address. Estimates only — review before saving.</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <RadioGroupItem value="api" id="mode-api" className="mt-1" />
            <div>
              <Label htmlFor="mode-api" className="font-medium cursor-pointer">Tax API</Label>
              <p className="text-sm text-muted-foreground">Use a connected provider (TaxJar / Avalara). Provider integration coming in a later phase.</p>
            </div>
          </div>
        </RadioGroup>
      </CardContent>
    </Card>
  );
}
